import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Itemvideo from './../atoms/ItemVideo'
import Filter from './../atoms/Filter'
import ProductSelection from '../atoms/ProductSelection'

const styles = (theme => ({
  root: {
    width: '100%',
    background: 'transparent',
    padding: 0,
  },
  header: {
    borderBottom: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
    margin: '0 0 24px 0',
    width: '100%',
    flexWrap: 'wrap',
  },
  body: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 24,
    '@media (max-width: 1279px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      maxWidth: 604, // 2 × 290px cards + 24px gap, same as the landing rows
      marginInline: 'auto',
    },
    '@media (max-width: 640px)': {
      gridTemplateColumns: '1fr',
      maxWidth: 290,
    },
    justifyItems: 'center',
    alignItems: 'start',
  },

  message: {
    gridColumn: '1 / -1',
    width: '100%',
    textAlign: 'center',
    fontStyle: 'italic',
    display: 'block',
    color: '#305178',
  },
})
)

function VideoList(data){
    const {classes,videos,message,onSelectedFilter,children,orderByAsc,onProductFilter,products,activeProduct,onPlayVideo} = data

    function onSelectedFilterAplied (filterBy,descendingorderBy){

        if(onSelectedFilter !== null){
            onSelectedFilter(filterBy,descendingorderBy)
        }
    }

    const onProductFilterApplied = (product) => {
        try {
            if(onProductFilter) {
                onProductFilter(product)
            }
        }
        catch(error) {
            console.log(error)
        }
    }

    return(
        <div>
            <div className={`${classes.root} listVideos`}>
                <div id='video_header' className={classes.header}>
                    <ProductSelection onSelected={ onProductFilterApplied }
                                    products={ products }
                                    active={ activeProduct } />
                    <Filter onSelected={ onSelectedFilterAplied }  orderByAsc = {orderByAsc} />
                </div>
                <div className={`${classes.body} bodyList`}>
                {children}
                {
                videos ? videos.length > 0 ?
                    videos.map((val,index) => {
                        return (
                            <Itemvideo key={val.id || index} data = {val} fx="vignette"
                                    product={val.product}
                                    configData={{anchorLinked:false,onclickedPbIcon : onPlayVideo}}>
                            </Itemvideo>
                        )
                })
                :
                (<span className={classes.message}>{message}</span>)
                :
                (<span className={classes.message}>{message}</span>)
                }
            </div>
        </div>
        </div>

    )
}
VideoList.propTypes = {
    videos: PropTypes.array,
    emptyvideosMessage:PropTypes.string,
    onPlayVideo: PropTypes.func,
}

VideoList.defaultProps = {
    message:'',
    onSelectedFilter:null,

}
const VideoListStyles = withStyles(styles)(VideoList)
export default VideoListStyles
